// src/pages/Home/Home.i18n.ts

export default {
    namespace: 'Home',
    translations: {
        zh: {
            hero: {
                title1: '未来世界',
                title2Prefix: '智能驱动的',
                title2Highlight: '未来',
                title2Suffix: '解决方案',
                btn: '探索解决方案'
            },
            about: {
                subtitle: 'About Us',
                title: '公司理念与愿景',
                cta: '查看关于我们 →',
                philosophy: {
                    title: 'AI - Solve',
                    subtitle: 'AGI + Embedded Intelligence',
                    titleDesc: '智能驱动的未来解决方案',
                    subtitleDesc: '我们以「通用人工智能」与「具身智能」为核心，通过技术融合创造突破性价值。',
                    speed: '敏捷响应应对技术变革',
                    opportunity: '为人才与企业构建双向机遇',
                    link: '建立全球科技生态的连接',
                    value: '通过精准匹配实现多维价值增值',
                    experience: '追求极致的服务体验与专业卓越'
                },
                mission: {
                    tag: 'MISSION 使命',
                    text: '"让科技人才找到理想工作，让企业找到合适人才"'
                },
                vision: {
                    tag: 'VISION 愿景',
                    text: '"成为定义数字科技人才平台标准的全球领导者"'
                },
                teamTitle: '核心人物概览',
                teamCta: '查看核心人物 →',
                // 将单纯的名字数组改为包含 name 和 imgKey 的对象数组
                teamMembers:[
                    { name: '福田敏男', imgKey: 'fukuda' },
                    { name: '久保田直行', imgKey: 'kubota' },
                    { name: '许 春山', imgKey: 'xu' },
                    { name: '真锅智章', imgKey: 'manabe' },
                    { name: 'Yoshida Kaede', imgKey: 'yoshida' },
                    { name: '松本 有', imgKey: 'matsumoto' },
                    { name: '田中 理', imgKey: 'tanaka' },
                    { name: '五十岚 章夫', imgKey: 'igarashi' }
                ]
            },
            services: {
                subtitle: 'SERVICES',
                titlePrefix: '一站式',
                titleHighlight: '出海',
                titleSuffix: '服务',
                tags:['10年海外市场经验', '50+标准服务模块', '1000+海外科技公司合作经验', '100+优质专家、导师资源'],
                imgText: '一站式数字化出海解决方案展示图',
                kicker: 'Expertise in Global Market Entry',
                slogan: '让科技人才找到理想工作，让企业找到合适人才',
                overview: '依托跨境人才网络、产业资源整合能力与项目交付经验，我们为中国企业与科技人才进入海外市场，提供从资源链接到项目落地的一站式出海服务。',
                description: '联合东京人工智能社区，东京都立大学，TAMA协会、苏州工业园区、上海人工智能研究院、中日科技产业交流平台等20多家垂直领域核心合作伙伴，为企业和个人打造专属一站式数字化出海解决方案。',
                highlights: [
                    '为顶尖科技人才提供实现职业理想的全球化舞台',
                    '助力企业高效获取驱动创新的核心人才资产',
                    '构建人才与企业共同成长的可持续科技生态'
                ],
                values: {
                    label: 'VALUES',
                    title: '价值观',
                    items: ['聚力', '专注', '创新', '卓越', '共赢']
                },
                tob: {
                    title: 'TO B',
                    target: '针对企业端',
                    desc: '个性化制定：市场调研 + 合规性对策 + 营销基础搭建 + 行业咨询 + 产品服务'
                },
                toc: {
                    title: 'TO C',
                    target: '针对个人端',
                    desc: '1+4+N 一站式服务 = 一个平台 + 4个系统 + N个服务'
                },
                whyChooseUs: {
                    label: 'WHY US',
                    title: '为什么选择我们',
                    intro: '我们的成员来自各大外资企业、日本本土咨询公司以及科技巨头，长期为不同行业客户提供持续增值服务，帮助中国企业降低出海试错成本与落地失败风险。',
                    items: [
                        {
                            title: '“人脉 + 新对接”双轮驱动，提高出海成功率',
                            desc: '通过社群资源与数据化对接机制同步推进，让企业在更短周期内找到真正可转化的合作机会。',
                            bullets: [
                                '依托东京人工智能社区与未来世界平台沉淀的高质量人脉网络',
                                '通过独特的数据框架，一对一匹配企业资源与目标对象'
                            ]
                        },
                        {
                            title: '中日双语协调与专家协作，保证项目质量',
                            desc: '从执行协调到项目管理，我们以双语沟通、行业理解和过程管控保障交付质量。',
                            bullets: [
                                '由精通中文、日文的协调员进行质量控制与跨文化沟通',
                                '具备扎实劳动力管理能力，可与考勤表及面向全球协作的外部工具联动',
                                '大数据行业专家与专业顾问可作为 PMO 和客户经理深度参与项目'
                            ]
                        },
                        {
                            title: '快速响应机制，帮助企业抢占市场窗口',
                            desc: '当客户存在紧急对接需求时，我们能够快速启动评估与资源匹配流程，缩短从咨询到行动的时间差。',
                            bullets: [
                                '支持快速填写申请表，提交后即可启动服务流程',
                                '最快 3 天内响应贵公司的具体需求'
                            ]
                        }
                    ]
                }
            },
            solutions: {
                subtitle: 'SOLUTION',
                title: 'AI人才解决方案集合',
                cta: '查看 AI Family →',
                aiHr: {
                    title: '我是AI人才HR,',
                    p1: '我的使命是帮助科技人才找到理想的工作，也帮助企业找到最合适的人才。',
                    p2: '拥有丰富的人才库，实现高效、精准的人才匹配。',
                    p3: '无论是规划职业发展，还是优化招聘流程，我都致力于让每一次匹配更智能、更可靠。'
                },
                list:[
                    { num: '01', title: 'Dify 解决方案', desc: '帮助企业和人才高效连接，实现精准匹配。' },
                    { num: '02', title: 'AI 面试解决方案', desc: '评估候选人能力与潜力，降低人为偏差。' },
                    { num: '03', title: 'AI 教员解决方案', desc: '提供个性化指导，制定学习计划。' },
                    { num: '04', title: 'AI 简历解决方案', desc: '自动解析优化简历，智能匹配岗位。' }
                ]
            },
            news: {
                subtitle: 'NEWS',
                title: '最新动态',
                imgPlaceholder: '活动图占位',
                more: '了解详情 →',
                joinBtn: '加入我们 →',
                items: {
                    card1: {
                        tag: '活动 TO B',
                        title: '探访海外·解码转型',
                        desc: '📅 时间：2025年9月10-11日\n本次参与活动旨在为中国 AI SaaS 企业搭建一个深入海外市场的桥梁...'
                    },
                    card2: {
                        stamp: 'HIRE',
                        tag: '招聘',
                        title: 'AI技术工程师',
                        desc: '寻找具有卓越 AI 模型微调能力的顶尖人才...'
                    },
                    card3: {
                        tag: '事件',
                        title: '集团XXX项目获奖',
                        desc: '凭借在数字科技人才匹配领域的创新性技术应用，我司最新孵化项目荣获大奖...'
                    }
                }
            }
        },
        en: {
            hero: {
                title1: 'FUTURE WORLD',
                title2Prefix: 'Smart-Driven ',
                title2Highlight: 'Future',
                title2Suffix: ' Solutions',
                btn: 'Explore Solutions'
            },
            about: {
                subtitle: 'About Us',
                title: 'Company Philosophy & Vision',
                cta: 'View About Us →',
                philosophy: {
                    title: 'AI - Solve',
                    subtitle: 'AGI + Embedded Intelligence',
                    titleDesc: 'Smart-Driven Future Solutions',
                    subtitleDesc: 'Taking "Artificial General Intelligence" and "Embodied Intelligence" as our core, we create breakthrough value through technological integration.',
                    speed: 'Agile response to technological changes',
                    opportunity: 'Build two-way opportunities for talent and enterprises',
                    link: 'Establish connections in the global tech ecosystem',
                    value: 'Achieve multi-dimensional value enhancement through precise matching',
                    experience: 'Pursue ultimate service experience and professional excellence'
                },
                mission: {
                    tag: 'MISSION',
                    text: '"Helping tech talents find ideal jobs, helping enterprises find the right talents"'
                },
                vision: {
                    tag: 'VISION',
                    text: '"To be the global leader defining the platform standards for digital tech talents"'
                },
                teamTitle: 'Core Team Overview',
                teamCta: 'View Core People →',
                teamMembers:[
                    { name: 'Toshio Fukuda', imgKey: 'fukuda' },
                    { name: 'Naoyuki Kubota', imgKey: 'kubota' },
                    { name: 'Chunshan Xu', imgKey: 'xu' },
                    { name: 'Tomoaki Manabe', imgKey: 'manabe' },
                    { name: 'Kaede Yoshida', imgKey: 'yoshida' },
                    { name: 'Yu Matsumoto', imgKey: 'matsumoto' },
                    { name: 'Osamu Tanaka', imgKey: 'tanaka' },
                    { name: 'Akio Igarashi', imgKey: 'igarashi' }
                ]
            },
            services: {
                subtitle: 'SERVICES',
                titlePrefix: 'One-stop ',
                titleHighlight: 'Global Expansion',
                titleSuffix: ' Services',
                tags:['10 Years Overseas Market Exp', '50+ Standard Service Modules', '1000+ Overseas Tech Co. Coops', '100+ Premium Experts/Mentors'],
                imgText: 'One-stop Digital Expansion Solution Display',
                kicker: 'Expertise in Global Market Entry',
                slogan: 'Helping tech talent find ideal jobs and helping enterprises find the right talent',
                overview: 'Backed by cross-border talent networks, industry resources, and hands-on delivery experience, we provide one-stop global expansion services for Chinese enterprises and tech professionals entering overseas markets.',
                description: 'Partnering with over 20 core vertical partners including the Tokyo AI Community, Tokyo Metropolitan University, TAMA Association, Suzhou Industrial Park, Shanghai AI Laboratory, and the Sino-Japanese Technology Industry Exchange Platform, we create exclusive one-stop digital solutions for enterprises and individuals expanding overseas.',
                highlights: [
                    'Create a global stage where top tech talent can realize their career ambitions',
                    'Help enterprises efficiently secure the core talent assets that drive innovation',
                    'Build a sustainable tech ecosystem where talent and enterprises grow together'
                ],
                values: {
                    label: 'VALUES',
                    title: 'Our Values',
                    items: ['Synergy', 'Focus', 'Innovation', 'Excellence', 'Win-Win']
                },
                tob: {
                    title: 'TO B',
                    target: 'For Enterprises',
                    desc: 'Customized formulation: Market research + Compliance countermeasures + Marketing foundation + Industry consulting + Product services'
                },
                toc: {
                    title: 'TO C',
                    target: 'For Individuals',
                    desc: '1+4+N One-stop Service = 1 Platform + 4 Systems + N Services'
                },
                whyChooseUs: {
                    label: 'WHY US',
                    title: 'Why Choose Us',
                    intro: 'Our team comes from leading multinational firms, Japanese consulting companies, and global technology giants. We continuously deliver value-added services across industries and help Chinese companies reduce the risks of failed overseas expansion.',
                    items: [
                        {
                            title: 'A dual engine of network access and new business matching',
                            desc: 'We combine trusted relationships with structured resource matching so clients can identify high-potential opportunities faster and with more confidence.',
                            bullets: [
                                'Leverage the relationship network built through the Tokyo AI Community and the Future World platform',
                                'Use our proprietary data framework to match enterprises with target resources one-on-one'
                            ]
                        },
                        {
                            title: 'Bilingual coordination and expert oversight for quality delivery',
                            desc: 'From execution management to stakeholder communication, we protect quality through language capability, domain expertise, and rigorous process control.',
                            bullets: [
                                'Quality control is handled by coordinators fluent in both Chinese and Japanese',
                                'Strong workforce management, linked to timesheets and external tools designed for global collaboration',
                                'Big data specialists and professional consultants can join as PMO and client managers'
                            ]
                        },
                        {
                            title: 'Rapid response for time-sensitive market opportunities',
                            desc: 'When clients need urgent introductions or project support, we can launch evaluation and matching quickly and shorten the gap between inquiry and execution.',
                            bullets: [
                                'If you need to connect with customers urgently, simply submit a quick application and we can begin immediately',
                                'Fastest response to your company requirements within as little as 3 days'
                            ]
                        }
                    ]
                }
            },
            solutions: {
                subtitle: 'SOLUTION',
                title: 'AI Talent Solutions',
                cta: 'View AI Family →',
                aiHr: {
                    title: 'I am an AI Talent HR,',
                    p1: 'My mission is to help tech talents find their ideal jobs and help companies find the most suitable candidates.',
                    p2: 'Equipped with a rich talent pool to achieve efficient and precise matching.',
                    p3: 'Whether planning career development or optimizing recruitment processes, I am dedicated to making every match smarter and more reliable.'
                },
                list:[
                    { num: '01', title: 'Dify Solutions', desc: 'Help enterprises and talents connect efficiently for precise matching.' },
                    { num: '02', title: 'AI Interview Solutions', desc: 'Evaluate candidate capabilities and potential, reducing human bias.' },
                    { num: '03', title: 'AI Tutor Solutions', desc: 'Provide personalized guidance and develop study plans.' },
                    { num: '04', title: 'AI Resume Solutions', desc: 'Automatically parse and optimize resumes for smart job matching.' }
                ]
            },
            news: {
                subtitle: 'NEWS',
                title: 'Latest Updates',
                imgPlaceholder: 'Event Image Placeholder',
                more: 'Learn More →',
                joinBtn: 'Join Us →',
                items: {
                    card1: {
                        tag: 'Event TO B',
                        title: 'Explore Overseas · Decode Transformation',
                        desc: '📅 Date: Sep 10-11, 2025\nThis event aims to build a bridge for Chinese AI SaaS enterprises to enter overseas markets...'
                    },
                    card2: {
                        stamp: 'HIRE',
                        tag: 'Recruitment',
                        title: 'AI Tech Engineer',
                        desc: 'Looking for top talent with outstanding AI model fine-tuning capabilities...'
                    },
                    card3: {
                        tag: 'News',
                        title: 'Group XXX Project Wins Award',
                        desc: 'With innovative technical applications in digital tech talent matching, our latest incubation project won the grand prize...'
                    }
                }
            }
        },
        ja: {
            hero: {
                title1: 'ミライワールド',
                title2Prefix: 'スマートに進化する',
                title2Highlight: '未来の',
                title2Suffix: 'ソリューション',
                btn: 'ソリューションを探索'
            },
            about: {
                subtitle: 'About Us',
                title: '企業理念とビジョン',
                cta: '会社概要を見る →',
                philosophy: {
                    title: 'AI - Solve',
                    subtitle: 'AGI + Embedded Intelligence',
                    titleDesc: 'スマートに進化する未来のソリューション',
                    subtitleDesc: '「汎用人工知能」と「エンボディドAI」をコアとし、技術の融合を通じてブレークスルーとなる価値を創造します。',
                    speed: '技術革新に対する俊敏な対応',
                    opportunity: '人材と企業に双方向の機会を構築',
                    link: 'グローバルなテクノロジーエコシステムの構築',
                    value: '精密なマッチングによる多角的な価値向上',
                    experience: '究極のサービス体験と専門的な卓越性の追求'
                },
                mission: {
                    tag: 'MISSION ミッション',
                    text: '"技術人材には理想の仕事を、企業には最適な人材を"'
                },
                vision: {
                    tag: 'VISION ビジョン',
                    text: '"デジタルテクノロジー人材プラットフォームの標準を定義するグローバルリーダーになる"'
                },
                teamTitle: 'コアメンバーの概要',
                teamCta: '核心人物を見る →',
                teamMembers:[
                    { name: '福田 敏男', imgKey: 'fukuda' },
                    { name: '久保田 直行', imgKey: 'kubota' },
                    { name: '許 春山', imgKey: 'xu' },
                    { name: '真鍋 智章', imgKey: 'manabe' },
                    { name: '吉田 楓', imgKey: 'yoshida' },
                    { name: '松本 有', imgKey: 'matsumoto' },
                    { name: '田中 理', imgKey: 'tanaka' },
                    { name: '五十嵐 章夫', imgKey: 'igarashi' }
                ]
            },
            services: {
                subtitle: 'SERVICES',
                titlePrefix: 'ワンストップ',
                titleHighlight: '海外進出',
                titleSuffix: 'サービス',
                tags:['海外市場10年の経験', '50以上の標準サービスモジュール', '海外IT企業との連携1000社以上', '100名以上の優秀な専門家・メンター'],
                imgText: 'ワンストップデジタル海外進出ソリューション',
                kicker: 'Expertise in Global Market Entry',
                slogan: '技術人材には理想の仕事を、企業には最適な人材を',
                overview: '越境人材ネットワーク、産業リソース、実行支援の知見を基盤に、中国企業およびテクノロジー人材の海外市場進出を、リソース接続から実装までワンストップで支援します。',
                description: '東京人工知能コミュニティ、東京都立大学、TAMA協会、蘇州工業園区、上海人工知能研究院、中日テクノロジー産業交流プラットフォームなど、20以上の垂直領域のコアパートナーと連携し、企業や個人の海外進出に向けた専用のワンストップデジタルソリューションを構築します。',
                highlights: [
                    'トップクラスのテック人材にグローバルなキャリア実現の舞台を提供',
                    '企業がイノベーションを牽引する中核人材を効率的に確保できるよう支援',
                    '人材と企業がともに成長する持続可能なテックエコシステムを構築'
                ],
                values: {
                    label: 'VALUES',
                    title: '価値観',
                    items: ['結集', '集中', '革新', '卓越', '共創']
                },
                tob: {
                    title: 'TO B',
                    target: '企業向け',
                    desc: 'カスタマイズ: 市場調査 + コンプライアンス対策 + マーケティング基盤構築 + 業界コンサルティング + 製品サービス'
                },
                toc: {
                    title: 'TO C',
                    target: '個人向け',
                    desc: '1+4+N ワンストップサービス = 1プラットフォーム + 4システム + Nサービス'
                },
                whyChooseUs: {
                    label: 'WHY US',
                    title: '私たちが選ばれる理由',
                    intro: '当社メンバーは外資系企業、日本国内のコンサルティング会社、テクノロジー大手の出身者で構成され、幅広い業界のクライアントに継続的な付加価値を提供し、中国企業の海外進出失敗リスクを低減します。',
                    items: [
                        {
                            title: '「人脈 + 新規マッチング」の両輪で成功確率を高める',
                            desc: '信頼あるネットワークと構造化されたマッチングの両方を活用し、より短期間で実効性の高い接点づくりを実現します。',
                            bullets: [
                                '東京人工知能コミュニティと未来世界プラットフォームを通じて築いた人脈ネットワークを活用',
                                '独自のデータフレームワークにより、企業リソースを一対一で最適にマッチング'
                            ]
                        },
                        {
                            title: '中日バイリンガルの調整体制と専門家連携で品質を担保',
                            desc: '実務運営からプロジェクトマネジメントまで、言語力・業界理解・プロセス管理で安定した品質を支えます。',
                            bullets: [
                                '中国語・日本語に精通したコーディネーターが品質管理と異文化調整を担当',
                                '勤怠表やグローバル連携を想定した外部ツールと連動できる労務管理体制',
                                'ビッグデータ分野の専門家やコンサルタントが PMO や顧客マネージャーとして参画可能'
                            ]
                        },
                        {
                            title: 'スピーディーな対応で市場機会を逃さない',
                            desc: '緊急度の高い顧客開拓や案件支援にも、初期評価からリソース連携まで迅速に着手します。',
                            bullets: [
                                '急ぎで顧客接点が必要な場合は、簡易申請フォーム送信後すぐに対応開始',
                                '最短 3 日で企業ニーズへの初期対応が可能'
                            ]
                        }
                    ]
                }
            },
            solutions: {
                subtitle: 'SOLUTION',
                title: 'AI人材ソリューション',
                cta: 'AI Familyを見る →',
                aiHr: {
                    title: '私はAI人材HRです。',
                    p1: '私の使命は、技術人材が理想の仕事を見つけるのを助け、企業が最適な人材を見つけるのを支援することです。',
                    p2: '豊富な人材プールを持ち、効率的かつ正確な人材マッチングを実現します。',
                    p3: 'キャリア構築の計画から採用プロセスの最適化まで、すべてのマッチングをよりスマートで信頼できるものにすることに尽力しています。'
                },
                list:[
                    { num: '01', title: 'Dify ソリューション', desc: '企業と人材の効率的なつながりをサポートし、正確なマッチングを実現します。' },
                    { num: '02', title: 'AI 面接ソリューション', desc: '候補者の能力と可能性を評価し、人為的なバイアスを軽減します。' },
                    { num: '03', title: 'AI チューターソリューション', desc: 'パーソナライズされた指導を提供し、学習計画を策定します。' },
                    { num: '04', title: 'AI 履歴書ソリューション', desc: '履歴書を自動解析・最適化し、スマートに求人とマッチングします。' }
                ]
            },
            news: {
                subtitle: 'NEWS',
                title: '最新ニュース',
                imgPlaceholder: 'イベント画像のプレースホルダー',
                more: '詳細を見る →',
                joinBtn: '採用情報を見る →',
                items: {
                    card1: {
                        tag: 'イベント TO B',
                        title: '海外探訪・トランスフォーメーションの解読',
                        desc: '📅 日程: 2025年9月10-11日\nこのイベントは、中国のAI SaaS企業が海外市場に参入するための架け橋を築くことを目的としています...'
                    },
                    card2: {
                        stamp: 'HIRE',
                        tag: '採用',
                        title: 'AI技術エンジニア',
                        desc: '卓越したAIモデルのファインチューニング能力を持つトップ人材を募集しています...'
                    },
                    card3: {
                        tag: 'ニュース',
                        title: 'グループXXXプロジェクトが受賞',
                        desc: 'デジタルテクノロジー人材マッチング分野での革新的な技術応用により、当社の最新インキュベーションプロジェクトが大賞を受賞しました...'
                    }
                }
            }
        }
    }
};
